<script setup>

</script>
<template>
    <div class="report-inner">   
        <div class="card-wrap">
            <div class="card ai-news">
                <h5 class="card-title">AI·디지털 리터러시 교육 소식</h5>
                <p class="pt-5 pb-5">학생과 학부모를 위한 AI·디지털 리터러시 교육 소식을 안내합니다.</p>   
                <ul>
                    <li>
                        <div class="content">                                                       
                            <div class="thumb">
                                <img src="@/assets/images/result/ai_news_01.png" alt="소식1">
                            </div>
                            <div class="text-wrap">                                
                                <span class="category">특강</span>
                                <div class="title">서울로봇인공지능과학관</div>
                                <p class="subtitle">&lt;<span>학부모를 위한 AI 리터러시 교육</span>&gt;</p>
                            </div>                           
                        </div>  
                    </li>
                    <li>
                        <div class="content">   
                            <div class="thumb">
                                <img src="@/assets/images/result/ai_news_02.png" alt="소식2">
                            </div>
                            <div class="text-wrap">
                                <span class="category">전시</span>
                                <p class="title">서울로봇인공지능과학관신규 기획전시</p>
                                <p class="subtitle">&lt;<span>미스터리 놀이터 RE:PLAY</span>&gt;</p>
                            </div>
                        </div>  
                    </li>
                    <li>
                       <div class="content">                                                              
                            <div class="thumb">
                                <img src="@/assets/images/result/ai_news_03.png" alt="소식3">
                            </div>
                            <div class="text-wrap">
                                <span class="category">교육</span>
                                <p class="title">서울로봇인공지능과학관 방과후 & 주말 교육</p>
                                <p class="subtitle">&lt;<span>평일/주말 교육프로그램</span>&gt;</p>
                            </div>
                        </div>  
                    </li>
                    <li>
                        <div class="content">                                                           
                            <div class="thumb">
                                <img src="@/assets/images/result/ai_news_04.png" alt="소식4">
                            </div>
                            <div class="text-wrap">
                                <span class="category">교육</span>
                                <p class="title">디지털새싹</p>
                                <p class="subtitle">&lt;<span>2학기 프로그램 신청</span>&gt;</p>
                            </div>
                        </div>  
                    </li>
                    <li>
                        <div class="content">                                                           
                            <div class="thumb">
                                <img src="@/assets/images/result/ai_news_05.png" alt="소식5">
                            </div>
                            <div class="text-wrap">
                                <span class="category">체험</span>
                                <p class="title">과천과학관</p>
                                <p class="subtitle">&lt;<span>미래직업세상</span>&gt;</p>
                            </div>
                        </div>  
                    </li>
                    <li class="empty">
                        <div class="content">
                            <p>서울시 AI 교육센터</p>
                            <p>&lt;2026년 7월 중 개관 예정&gt;</p>
                            <p>소식지 첨부</p>
                        </div>   
                    </li>
                </ul> 
            </div>        
         </div>
    </div>    
</template>

<style lang="scss" scoped>
.ai-news {    
    ul {
        display: flex;
        flex-wrap: wrap;
        gap: 15px 20px;
        li {           
            width: calc((100% - 40px) / 3);      
            border: 1px solid #ccc;   
            border-radius: 8px;
            overflow: hidden;
            padding: 20px 20px 16px;
            .content {
                min-height: 280px;
                display: flex;
                flex-direction: column;
                align-items: center;   
                font-weight: 500;
                position: relative;
                .category {
                    padding: 2px 8px;
                    border-radius: 5px;
                    display: inline-block;      
                    border: 1px solid var(--main-ai-primary);
                    color: var(--main-ai-primary);  
                    font-size: 14px;
                    margin-top: 10px;
                }        
                .text-wrap {                         
                    width: 100%;
                    .title {font-size: 20px; font-weight: 600; text-wrap-style: balance; padding: 5px 0;}
                    .subtitle span {color: var(--main-ai-primary);}
                }                           
                .thumb {
                    height: 310px;
                    overflow: hidden;
                    background-color: var(--smoe-gray-100);
                    width: 100%;                  
                    display: flex;
                    justify-content: center;   
                    img {
                        object-fit: contain;    
                    }                     
                }
            }    
            &.empty {
                background-color: var(--smoe-gray-100);
                .content {min-height: auto; height: 100%;justify-content: center; gap: 5px;}
            }       
        }
    }      
}
</style>